import {Task} from 'redux-saga';
import {all} from 'redux-saga/effects';

import {sagaMiddleware} from 'desktop/store';

import {checkoutSaga} from './checkout/checkout';
import {creditCardPayment} from './creditCardPayment/creditCardPayment';
import {checkoutDeliveryStepSaga} from './deliveryStep/deliveryStepRootSaga/deliveryStepRootSaga';
import {checkoutDeliveryStepFormsSaga} from './deliveryStepFormsSaga/deliveryStepFormsSaga';
import {eecAnalyticsRootSaga} from './EECAnalytics/EECAnalytics';
import {savePaymentMethodSaga} from './paymentMethodSave/paymentMethodSave';
import {amazonSaga} from './paymentStep/paymentMethods/amazon/amazon/amazonV2';
import {applePaySaga} from './paymentStep/paymentMethods/applePay/applePay';
import {paymentMethodsSaga} from './paymentStep/paymentMethods/paymentMethods';
import {paymentStepSaga} from './paymentStep/paymentStep';
import {placeOrderRootSaga} from './placeOrder/placeOrder';
import {riskified} from './riskified';
import {checkoutShippingSaga} from './shipping/shipping';
import {updateShippingMethodSaga} from './updateShippingMethods/updateShippingMethods';

let task: Task | null = null;

/**
 * Begin of saga
 */
function* checkoutRootSaga() {
    yield all([
        checkoutSaga(),
        creditCardPayment(),
        checkoutShippingSaga(),
        savePaymentMethodSaga(),
        updateShippingMethodSaga(),
        riskified(),
        eecAnalyticsRootSaga(),
        placeOrderRootSaga(),
        checkoutDeliveryStepFormsSaga(),
        checkoutDeliveryStepSaga(),
        paymentStepSaga(),
        paymentMethodsSaga(),
        amazonSaga(),
        applePaySaga(),
    ]);
}

/**
 * This function is helper for starting root saga of checkout page,
 * it is checking task and actually runs saga if its null, if task is not null than it does nothing.
 * We need this function to prevent multiple running of same saga
 */
export const startCheckoutRootSaga = () => {
    if (task === null) {
        task = sagaMiddleware.run(checkoutRootSaga);
    }
};

/**
 * This function is helper for stopping root saga of checkout page
 * it is canceling task and change its value to null
 */
export const stopCheckoutRootSaga = () => {
    if (task) {
        task.cancel();
    }
    task = null;
};
